import { Box, Grid, Typography, useTheme } from "@mui/material";
import {
	EnhancedCheckboxRHF,
	EnhancedCheckboxRHFWithLabel,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../../RHookFormMaskedTextFieldWithVerifyLabel";

interface IAccountantBankInfoSetupFieldsPanel {
	isAdminUser: number;
	accountantDDL: any;
	onAccountantBankSelectionChangeHandler: (params: any) => void;
	onVerifyBankClickedHandler: () => void;
	savedStatus: any
	id: any
}
export const AccountantBankInfoSetupFieldsPanel: FC<
	IAccountantBankInfoSetupFieldsPanel
> = ({
	isAdminUser,
	accountantDDL,
	onAccountantBankSelectionChangeHandler,
	onVerifyBankClickedHandler,
	savedStatus,
	id
}) => {
		const theme = useTheme();
		return (
			<Box
				sx={{
					padding: "0",
					"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
				}}
			>
				<EnhancedDropDownRHFWithLabel
					label="Accountant"
					selectName="accountantId"
					testId={`accountantId`}
					labelPosition={LabelPosition.Top}
					items={accountantDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					onSelectionChangeHandler={onAccountantBankSelectionChangeHandler}
				/>
				<RHookFormTextFieldWithLabel
					label="Name"
					id="name"
					testId={`name`}
					labelPosition={LabelPosition.Top}
					labelColumns={4}
					fieldColumns={8}
				/>
				{/* <RHookFormTextFieldWithLabel
				label="Account No"
				id="accountNo"
				testId={`Account-No`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/> */}
				{/* <RHookFormMaskedTextFieldWithLabel
					label="Account No"
					id="accountNo"
					testId={`accountNo`}
					labelPosition={LabelPosition.Top}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					labelColumns={4}
					fieldColumns={8}
				/> */}
				<RHookFormMaskedTextFieldWithVerifyLabel
					id="accountNo"
					testId={`accountNo`}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					label={
						<>
							<Grid> Account No&nbsp;
								<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
									[Verify]
								</span>
							</Grid>
						</>
					}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Branch Transit Number"
					id="branchTransitNumber"
					testId={`branchTransitNumber`}
					labelPosition={LabelPosition.Top}
					placeholder={"00000"}
					inputMaskPattern={"00000"}
					labelColumns={4}
					fieldColumns={8}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank Financial No"
					id="bankFinancialNo"
					testId={`bankFinancialNo`}
					labelPosition={LabelPosition.Top}
					placeholder={"0000"}
					inputMaskPattern={"0000"}
					labelColumns={4}
					fieldColumns={8}
				/>

				<EnhancedCheckboxRHF
					name="primaryAccount"
					checked={false}
					testId="Primary-Account"
					checkboxLabel={"Primary Account"}
				/>

				{isAdminUser === 400 ? <EnhancedDropDownRHFWithLabel
					label="Status"
					selectName="status"
					testId={`Status`}
					labelPosition={LabelPosition.Top}
					items={[
						{ label: "Active", value: 100 },
						{ label: "Inactive", value: 200 },
					]}
					selectedItem={200}
					labelColumns={4}
					fieldColumns={8}
				/> :
					id && savedStatus && savedStatus !== "" ?
						<Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px", display: "flex", justifyContent: "space-between" }}>
							<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
								Status
							</Typography>
							<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
								{savedStatus}
							</Typography>
						</Box> : <></>
				}
			</Box>
		);
	};
